import * as z from "zod";
import { mutator } from "./mutator";

export const resetOAuthConnectionSchema = z.object({
  oauthConnectionId: z.string(),
});

export const resetOAuthConnection = mutator({
  schema: resetOAuthConnectionSchema,
  resolve: {
    connection: { kind: "oauthConnection", from: "oauthConnectionId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.connection.connectedApps?.[0]?.id ?? "",
    },
  ],
  fn: async ({ tx, args: { connection } }) => {
    await tx.mutate.oauthConnections.update({
      id: connection.id,
      status: "not_connected",
      tokenType: null,
      accessTokenExpiresAt: null,
      refreshTokenExpiresAt: null,
      lastError: null,
      updatedAt: Date.now(),
    });
  },
});
